import { Typography } from '@mui/material';
import { useCallback } from 'react';
import { Trans } from 'react-i18next';

type GroupMessageSmsMessageLengthProps = {
  message: string;
  splitMessageLength: number;
};

export const GroupMessageSmsMessageLength = (props: GroupMessageSmsMessageLengthProps) => {
  const { message, splitMessageLength } = props;
  // const { t } = useTranslation(['groupmessage']);

  const splitMessage = useCallback(
    (str) => {
      const chunks: string[] = [];

      for (let i = 0, charsLength = str.length; i < charsLength; i += splitMessageLength) {
        chunks.push(str.substring(i, i + splitMessageLength));
      }

      return chunks;
    },
    [splitMessageLength],
  );

  const hasDataProp = /\[[^\]]+\]/g.test(message);

  const splittedMessages = splitMessage(message);

  return (
    <Typography component='div' variant='body1' sx={{ fontWeight: 100, my: 1 }}>
      <Trans
        i18nKey='groupMessage:sms.messageLengthInfo'
        values={{
          messageLength: message.length,
          segmentCount: splittedMessages.length,
        }}
      />
      {hasDataProp && (
        <Typography component='div' sx={{ color: (thm) => thm.palette.info.dark, fontWeight: 500 }}>
          <Trans i18nKey='groupMessage:sms.dataFieldWarning' />
        </Typography>
      )}
    </Typography>
  );
};
